var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "domain-select" }, [
    _c("div", { staticClass: "domain-select__header" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c(
            "div",
            {
              staticClass:
                "domain-select__header-item typography--body-3 typography--color-secondary typography--font-weight-bold"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("evaluations.domain_select.header.title")) +
                  "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _c(
            "div",
            {
              staticClass:
                "domain-select__header-item typography--caption typography--color-secondary text-right"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("evaluations.domain_select.header.description")
                  ) +
                  "\n        "
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "domain-select__option-list" },
      _vm._l(_vm.domains, function(domain) {
        return _c("DomainSelectOption", {
          key: domain.id,
          attrs: {
            domain: domain,
            loading: _vm.loading,
            "is-selected": _vm.isSelectedDomain(domain.id)
          },
          on: {
            "domain-option-clicked": function($event) {
              return _vm.$emit("domain-option-clicked", domain.id)
            }
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8febac6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8febac6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/evaluations/components/DomainSelect.vue
// module id = wNoM
// module chunks = 1